import React from 'react';
import type { ButtonProps } from '@hover/blueprint';
import { Button } from '@hover/blueprint';

interface IScrollerButtonProps extends ButtonProps {
  anchorRef: { current: HTMLElement | null };
}

export const ScrollerButton: React.FC<IScrollerButtonProps> = ({
  anchorRef,
  onClick,
  ...buttonProps
}) => (
  <Button
    onClick={e => {
      if (anchorRef?.current) {
        anchorRef.current.scrollIntoView({
          behavior: 'smooth',
        });
      }
      onClick?.(e);
    }}
    fill="minimal"
    color="neutral"
    {...buttonProps}
  />
);
